@use "@/styles/variables" as *;

.content {
	display: flex;
	flex-direction: column;
	gap: 12px;
	min-width: 0;
}

.headerCard {
	position: relative;
	padding: 12px 14px;
	border: 1px solid $gray-200;
	border-radius: 10px;
	background: linear-gradient(145deg, #ffffff 0%, #fcfdf8 70%, #f8fbf0 100%);
	overflow: hidden;

	&::after {
		content: "";
		position: absolute;
		right: -24px;
		top: -28px;
		width: 90px;
		height: 90px;
		border-radius: 999px;
		background: radial-gradient(circle, rgba(127, 176, 47, 0.18) 0%, rgba(127, 176, 47, 0.02) 70%, transparent 100%);
		pointer-events: none;
	}
}

.headerTop {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	flex-wrap: wrap;
}

.headerBadge {
	display: inline-flex;
	align-items: center;
	font-size: 0.65rem;
	font-weight: 700;
	color: $primary-color;
	background: rgba(127, 176, 47, 0.12);
	border: 1px solid rgba(127, 176, 47, 0.22);
	border-radius: 999px;
	padding: 3px 8px;
	text-transform: uppercase;
	letter-spacing: 0.04em;
	flex-shrink: 0;
}

.headerHint {
	margin: 8px 0 0;
	font-size: 0.78rem;
	line-height: 1.4;
	color: #64748b;
	width: 100%;
}

.metaRow {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 8px;
	margin-left: auto;
}

.metaDivider {
	width: 1px;
	height: 14px;
	background: #cbd5e1;
}

.metaEstate {
	font-size: 0.8rem;
	font-weight: 600;
	color: #334155;
}

.productList {
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin: 0;
	padding: 0;
	list-style: none;
	max-height: min(52vh, 420px);
	overflow-y: auto;
	padding-right: 2px;
}

.productRow {
	display: grid;
	grid-template-columns: minmax(0, 1fr) minmax(200px, 36%);
	align-items: center;
	gap: 12px;
	padding: 10px 12px;
	border: 1px solid $gray-200;
	border-radius: 8px;
	background: #fff;
	transition:
		border-color 0.15s ease,
		box-shadow 0.15s ease;

	&:hover {
		border-color: rgba($primary-color, 0.35);
		box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);
	}
}

.productRowEdited {
	border-color: rgba($primary-color, 0.35);
	background: rgba(127, 176, 47, 0.03);
}

.productInfo {
	display: flex;
	flex-direction: column;
	gap: 4px;
	min-width: 0;
}

.productName {
	font-size: 0.875rem;
	font-weight: 500;
	line-height: 1.3;
	color: #111827;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.editedHint {
	font-size: 0.68rem;
	font-weight: 600;
	color: $primary-color;
}

.priceField {
	width: 100%;
}

.priceInput {
	width: 100%;
}

.emptyState {
	padding: 20px 16px;
	border: 1px dashed #cbd5e1;
	border-radius: 8px;
	text-align: center;
	font-size: 0.85rem;
	color: #64748b;
}

@media (max-width: 560px) {
	.productRow {
		grid-template-columns: 1fr;
	}
}
